import React, { useMemo } from 'react';
import { computeKpis, computeKpisByYear, format } from '../kpis';

const tone = (value) => (value == null || value === 0 ? '' : value > 0 ? 'positive-value' : 'negative-value');

function Kpi({ label, stat, render, signed }) {
  return (
    <div className="kpi">
      <div className="kpi-label">{label}</div>
      <div className={`kpi-value ${signed ? tone(stat.mean) : ''}`}>{render(stat.mean)}</div>
      <div className="kpi-sub">{stat.n > 0 ? `median ${render(stat.median)}` : 'no data'}</div>
    </div>
  );
}

// Four headline numbers for the listings currently in view
export default function KpiBox({ listings }) {
  const kpis = useMemo(() => computeKpis(listings), [listings]);

  const years = useMemo(() => computeKpisByYear(listings), [listings]);

  return (
    <div className="kpi-box">
      <div className="kpi-grid">
        <Kpi label="Avg. Sold Price" stat={kpis.soldPrice} render={(v) => format.euro(v)} />
        <Kpi label="Avg. Time on Market" stat={kpis.daysOnMarket} render={format.duration} />
        <Kpi label="Avg. Price Uplift (EUR)" stat={kpis.upliftEur} render={(v) => format.euro(v, true)} signed />
        <Kpi label="Avg. Price Uplift (%)" stat={kpis.upliftPct} render={format.percent} signed />
      </div>
      {years.length > 0 && (
        <details className="kpi-years">
          <summary>Breakdown by year of sale</summary>
          <table>
            <thead>
              <tr><th>Year</th><th>Avg. sold</th><th>Avg. time</th><th>Uplift €</th><th>Uplift %</th></tr>
            </thead>
            <tbody>
              {years.map((y) => (
                <tr key={y.year} title={`${y.count} sold listing${y.count === 1 ? '' : 's'}`}>
                  <td>{y.year}</td>
                  <td>{format.euro(y.soldPrice)}</td>
                  <td>{format.months(y.daysOnMarket)}</td>
                  <td className={tone(y.upliftEur)}>{format.euroK(y.upliftEur, true)}</td>
                  <td className={tone(y.upliftPct)}>{format.percent(y.upliftPct)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </details>
      )}
      <div className="kpi-footnote">
        Based on {kpis.soldCount} sold listing{kpis.soldCount === 1 ? '' : 's'} in view
        {kpis.excluded > 0 ? ` · ${kpis.excluded} excluded (sale dated before listing)` : ''}
      </div>
    </div>
  );
}
